module.exports = __webpack_public_path__ + "static/media/namibia.3f4908e5.jpg";